export default __webpack_public_path__ + "static/media/Blank.6828eb51.svg";